import { LOGIN_ROUTE } from "@/utils/const";
import { getCookie } from "@/utils/cookies";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  const isAuth = getCookie("isAuth") === "true";

  if (!isAuth) {
    return <Navigate to={LOGIN_ROUTE} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
